import React from 'react';
import { SearchIcon, CalendarIcon } from 'lucide-react';
export const DocumentFilters = () => {
  return <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-425">
      <div className="relative flex-1" data-id="element-426">
        <input type="text" placeholder="Buscar documentos..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-427" />
        <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-428" />
      </div>
      <div className="flex gap-4" data-id="element-429">
        <div className="w-48" data-id="element-430">
          <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-431">
            <option value="" data-id="element-432">Tipo de archivo</option>
            <option value="pdf" data-id="element-433">PDF</option>
            <option value="presentation" data-id="element-434">Presentación</option>
            <option value="video" data-id="element-435">Video</option>
          </select>
        </div>
        <div className="relative w-48" data-id="element-436">
          <input type="date" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-437" />
          <CalendarIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-438" />
        </div>
      </div>
    </div>;
};